import React from "react";
import "./CosumtersProductsDashPage.css";
import { Link } from "react-router-dom"; // ✅ הוספת הייבוא
import CosumterProductsTableDash from "../../components/CosumterProductsTableDash/CosumterProductsTableDash";
import UploadProductFormDash from "../../components/UploadProductFormDash/UploadProductFormDash";
import AllProductsTableDash from "../../components/AllProductsTableDash/AllProductsTableDash";

const CosumtersProductsDashPage = () => {
  return (
    <div className="AddYad2TaxiForSaleForm-container">
      <div className="ButtonToDash-Button">
        <Link to="/dashboard">
          <button className="ButtonToDashbord">מעבר לדשבורד</button>
        </Link>
      </div>
      <CosumterProductsTableDash />
      <div>
        <UploadProductFormDash />
      </div>
      <div>
        <AllProductsTableDash />
      </div>
    </div>
  );
};

export default CosumtersProductsDashPage;
